<iframe class="canva" [attr.srcDoc]="structure[this.index]['text']" height="100%" width="100%"></iframe>
